import { Component, OnInit } from '@angular/core';
import { Portals } from '../../model/Portals';
import { DomSanitizer } from '@angular/platform-browser';
import { PortalService } from '../../services/PortalService';
import { NbDialogRef } from '@nebular/theme';
import { Router } from '@angular/router';
import { downloadFileUtil } from '../../../../shared/utils/file-downloader';


@Component({
  selector: 'Portaldetails',
  templateUrl: './portaldetails.component.html',
  styleUrls: ['./portaldetails.component.scss'],
})
export class PortalsDetailsComponent implements OnInit {
  model = {} as Portals;
  constructor(
    private sanitizer: DomSanitizer,
    private service: PortalService,
    private diag: NbDialogRef<PortalsDetailsComponent>,
    private route : Router
  ) {}

  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     }); 
  }
  downloadFile(fileName) {
    this.service.downloadFile(fileName).subscribe((blob) => {
      downloadFileUtil(blob, fileName);
    });
  }

  close() {
    this.diag.close();
  }
}
